import React, { Component } from 'react';
import './style.scss';
import { withRouter } from 'react-router-dom'; 
import { LanguageContext } from '../../providers/LanguageProvider';
import axios from 'axios';
import { titleUp } from '../../shared/helpers';
import FoodSelector from './FoodSelector/FoodSelector';
import MobileOrderBanner from '../../components/MobileOrderBanner/MobileOrderBanner';
import { tl } from '../../shared/helpers';
import { data } from '../FoodMenu/FoodSelector/CategoryMenu/translations';

const API_URL =  process.env.REACT_APP_API_URL;

class FoodMenu extends Component {
    state = {
        ourMenuPage: this.props.ourMenuPage,
        defaultCategory: 'featured',
        category: this.props.match.params.category ? (this.props.match.params.category.match(/^(breakfast|burgers|chicken|chubby-chicken|drinks|sides|kidspack|brewbar|featured|pret)$/) ? this.props.match.params.category : 'breakfast') : 'breakfast',
        //allFood: localStorage && localStorage.getItem("allFood") ? JSON.parse(localStorage.getItem("allFood")) : null,
        allFood: sessionStorage && sessionStorage.getItem("allFood") ? JSON.parse(sessionStorage.getItem("allFood")) : null,
        error: false,
        
    }

    // Grab the context!
    static contextType = LanguageContext;

    componentDidMount = () => {

        // // Check local storage or state for our-menu data
        // if((localStorage && localStorage.getItem("allFood")) || this.state.allFood !== null){
        //     // We have Food
        //     //let allFood = JSON.parse(localStorage.getItem("allFood"));
            
        // }else{
        //     //console.log('no food items')
        //     // If we have none, go get it.    
        //     this.getMenuData();
        // }

        if((sessionStorage && sessionStorage.getItem("allFood")) || this.state.allFood !== null){
            // We have Food
            //let allFood = JSON.parse(localStorage.getItem("allFood"));
            
        }else{
            //console.log('no food items')
            // If we have none, go get it.    
            this.getMenuData();
            console.log("get menu");
        }
    }

    shouldComponentUpdate = (prevProps, prevState, nextProps) => {
        // Check for category aka slug change
        if(this.props.match.params.category !== prevProps.match.params.category || this.state.allFood !== prevState.allFood || this.state.category !== prevState.category){
            //console.log('fs slug change ', this.props.match.params);
            
            return true;
        }else{
            //console.log('not updateing food selector');
            return false;
        }
       
    }

    getMenuData = () => {

        //axios.get(`${api_location}/api/menu/`)
        if(this.state.allFood === null || this.state.allFood === undefined){
            axios.get(`${API_URL}/api/menu/`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }})
                .then((response) => {
                   //console.log('response menu', response);
                    // Set Local Storage
                    // if(localStorage){
                    //     localStorage.setItem("allFood", JSON.stringify(response.data))
                    // }
                    // this.setState({
                    //     allFood: response.data
                    // })

                    // Set to session storage instead of local storage.
                    if(sessionStorage){
                        sessionStorage.setItem("allFood", JSON.stringify(response.data))
                    }
                    this.setState({
                        allFood: response.data
                    })
                    
                })
                .catch(error => {
                    console.log('oops, you\'re error is: ', error);
                    this.setState({
                        error: true
                    })
                })
        }

    }

    onCategoryChange = (e, cat) => {
        e.preventDefault();
        //console.log('change');
		this.setState({category: cat});
	//	this.props.onCategoryChange(cat);
    }
    
  

    render() {

        //console.log('foodselector props ',this.props.match.params.category);
        // console.log('menu props ',this.props);
         // Is there a new category?
         //let category  = this.state.category ? this.state.category : this.props.match.params.category;
         
         let category  = this.props.match.params.category ? this.props.match.params.category : this.state.defaultCategory;
         
         if(!this.props.ourMenuPage){
             //console.log('single page category');
            category  = this.state.category ? this.state.category : this.props.match.params.category;
            
         }
         
         //this.props.match.params.category ? category = this.props.match.params.category : category = this.state.defaultCategory;
         // Is it a valid category?
         let valid_category = category.match(/^(breakfast|burgers|chicken|chubby-chicken|drinks|sides|kidspack|brewbar|featured|pret)$/);
         //If not valid assign featured
         if(!valid_category){
                category = 'featured';
        }
         //Uppercase category to grab key/value
         let objKey = titleUp(category);
        
        //  if(category === 'kidspack') {
        //      categoryTitle = "Kid's Pack"
        //  } else if (category === 'chicken') {
        //      categoryTitle = "Chicken & more"     
        //  }
        // let objKey =  category;
         // Grab the categories if allFood has been set.
         //console.log('test test ', Object.keys(this.state.allFood))
         let categoryList = this.state.allFood !== null ? Object.keys(this.state.allFood) : [];

         // Featured may not exist, if there are no menu items currently being featured
         if (!categoryList.includes('featured')) categoryList.push('featured');
        //console.log('cat', categoryList);
        return (
            <>
                <section className="food-menu">
                    <div className="blockwrap">
                        {this.props.ourMenuPage ? 
                                <h1>
                                    {/*chicken title is different than menu option for whatever reason*/}
                                    {category === 'chicken' ?  
                                        tl(data, 'chicken_header', this.props.lang) 
                                    : 
                                        tl(data, category, this.props.lang)
                                    }
                                </h1>
                            :
                                <h1 className="explore-more">
                                    <span>{this.props.lang !== 'fr' ? 'Explore ' : 'Explorer '}</span>
                                    {this.props.lang !== 'fr' ? 'More Food' : ' d’autres articles du menu'}
                                </h1>
                        }
                        
                        <p>
                            {this.props.ourMenuPage === true ? 
                                this.props.lang !== 'fr' ? 'Discover the good food that makes us Canada’s favourite.' : 'Découvrez nos bons ingrédients qui font de nous les favoris au pays.'
                            :
                                ''
                            }
                           
                        </p>
                    </div>
                    {/* <FoodSelector caption="" initialCategory={category} slide={false} onLoad={this.loaded} onCategoryChange={this.categoryChange} /> */}

                   
                   
                    {   this.state.allFood ? 
                            <FoodSelector 
                                {...this.props}
                                caption="" 
                                category={category}
                                categoryFood={this.state.allFood[objKey]?.items ?? []}
                                categoryGuarantees={this.state.allFood[objKey]?.guarantees ?? []} 
                                //categoryGuarantees={Object.entries(this.state.allFood[objKey].guarantees)}
                                lang={this.context.language} 
                                navItems={categoryList} 
                                initialCategory={category} 
                                slide={false} 
                                onCategoryChange={this.onCategoryChange} 
                            />
                        :
                            null
                    }
               
                </section>
                <MobileOrderBanner lang={this.props.lang} />    
            </>
        );
    }
}

export default withRouter(FoodMenu);